export default "__VITE_ASSET__C7hBm3dh__"